import { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import { get } from '@/utils/api';

const POLL_MS = 60000;

/**
 * How many pending Assignments items the given child has (lesson quizzes +
 * homework, matching the Assignments Pending tab). Polls every minute,
 * refetches on window focus and on route change.
 */
export default function usePendingAssignmentsCount(childId) {
  const [count, setCount] = useState(0);
  const location = useLocation();

  useEffect(() => {
    if (!childId) {
      setCount(0);
      return undefined;
    }

    let mounted = true;

    const fetchCount = async () => {
      try {
        const res = await get(`/quiz/pending-work/${childId}?isCoreSkills=false`);
        if (!mounted) return;
        setCount(Array.isArray(res) ? res.length : 0);
      } catch {
        // Keep the last known value; a transient failure shouldn't flicker the badge.
      }
    };

    fetchCount();
    const interval = setInterval(fetchCount, POLL_MS);
    window.addEventListener('focus', fetchCount);
    return () => {
      mounted = false;
      clearInterval(interval);
      window.removeEventListener('focus', fetchCount);
    };
  }, [childId, location.pathname]);

  return count;
}
